"use client"
import Weather from "@/components/widget/weather";
import { useUserInfoStore } from "@/models/userInfo";
const RightSidebar = () => {
  const { isLogin, userLocation } = useUserInfoStore();
  if (!isLogin || !userLocation.zip && !userLocation.postalCode) {
    return <div className="flex-col w-64 pr-10 py-10 sticky right-0 top-0 h-full hidden lg:flex min-w-64"></div>
  }
  return (
    <nav className="flex-col w-64 pr-10 py-10 sticky right-0 top-0 h-full hidden lg:flex min-w-64 bg-inherit">
      {/* <div className="flex items-center justify-center mb-4 px-6 py-5 bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300"> */}
      <div className="flex items-center justify-center mb-4 px-6 py-5 rounded-xl border">
        <Weather />
      </div>
    </nav>
  );
};

export default RightSidebar;